import { useContext } from 'react';

import { CurrentAliceAppContext } from '../context/aliceAppContext';

export const useCurrentAliceApp = () => {
    const context = useContext(CurrentAliceAppContext);

    return context?.aliceApp;
};
